// extracted by mini-css-extract-plugin
module.exports = {"archidektOrange":"#fa890d","quantityBlue":"#698bc7","quantityGreen":"#1ebb6c","flex":"dropdown_flex__3C4mV","trigger":"dropdown_trigger__dAeyh","pulse":"dropdown_pulse__YDopK"};